import { AllCardsType } from '../data/all-cards'
import { formatCardLabel } from './card-label'

export type ComboPreviousStep = {
    step: number
    spreadTitle: string
    cards: AllCardsType[]
    response: string
}

export type ComboPreambleMeta = {
    firstStepIntro: string
    finalStepClosing: string
}

export const FLEXIBLE_COMBO_PREAMBLE: ComboPreambleMeta = {
    firstStepIntro:
        'Es la primera lectura de un combo armado a medida para este consultante. Enfocá esta tirada en su propio mensaje; las siguientes profundizarán el hilo.',
    finalStepClosing:
        'integrá lo revelado en las lecturas anteriores del combo en un cierre coherente, sin contradecir lo ya supervisado, y dejá un mensaje claro y accionable.',
}

export const buildComboPreamble = (
    comboName: string,
    stepNumber: number,
    totalSteps: number,
    previousSteps: ComboPreviousStep[],
    meta: ComboPreambleMeta
): string => {
    if (previousSteps.length === 0) {
        return `Esta lectura es el paso 1 de ${totalSteps} del combo "${comboName}". ${meta.firstStepIntro} No adelantes contenido de las tiradas siguientes.\n\n`
    }

    let block = `Esta lectura es el paso ${stepNumber} de ${totalSteps} del combo "${comboName}" para el mismo consultante.\nMantén coherencia narrativa con lo ya revelado en las lecturas supervisadas anteriores; profundiza el hilo sin contradecir.\n\n`

    for (const prev of previousSteps) {
        const cardsList = prev.cards
            .map((c) => formatCardLabel(c))
            .join(', ')
        block += `--- Paso ${prev.step}: ${prev.spreadTitle} ---\nCartas: ${cardsList}\nLectura supervisada:\n${prev.response}\n\n`
    }

    if (stepNumber === totalSteps) {
        block += `En el paso final, ${meta.finalStepClosing}\n\n`
    } else {
        block +=
            'Conectá esta lectura con lo revelado en la(s) tirada(s) anterior(es) sin repetir textualmente lo ya dicho.\n\n'
    }

    return block
}
